import styled from 'styled-components';

import Color from '../../styles/color';

const Container = styled.div`
  text-align: center;
  min-height: 1000px;
`;
const Content = styled.p`
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  color: ${Color.neutral90};
  text-align: center;
  margin-top: 18px !important;
  margin: auto;
`;

const SplitMessage = styled.hr`
  border: 1px solid ${Color.neutral60};
  margin: 30px 0px 30px 0px;
`;

export { Container, Content, SplitMessage };
